import {createThreeJSScene} from "./custom/threeConfigurator";

function initConfigurator() {
    const configuratorEl = document.querySelector('.itemcardEilaConfigurator');

    if (!configuratorEl || window._configuratorBooted) {
        return;
    }
    window._configuratorBooted = true;

    // Show configurator link button now that we know the configurator exists
    const configuratorLinkBtn = document.querySelector('.button--configuratorLink');
    if (configuratorLinkBtn) {
        configuratorLinkBtn.classList.add('is-visible');
    }

    const viewerEl = document.getElementById('viewer');
    createThreeJSScene(viewerEl || '#viewer');

    // Mark configurator as initialized after a short delay to allow setup
    setTimeout(() => {
        window._configuratorInitialized = true;
    }, 1000);
}

// the React portal inserts the item card as fragment after the page was loaded
if (document.readyState === 'complete') {
    initConfigurator();
} else {
    window.addEventListener('load', initConfigurator);
}
